import React from 'react';

export const MegaphoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3610_2697)">
      <g clipPath="url(#clip1_3610_2697)">
        <path
          d="M3 4.75311V17.7469C2.99988 17.863 3.02674 17.9776 3.07848 18.0817C3.13021 18.1857 3.20541 18.2762 3.29812 18.3462C3.39084 18.4162 3.49855 18.4637 3.61276 18.485C3.72697 18.5062 3.84456 18.5007 3.95625 18.4687L20.4562 13.6594C20.613 13.6145 20.7509 13.5198 20.8491 13.3895C20.9472 13.2593 21.0002 13.1006 21 12.9375V9.56249C21.0002 9.39941 20.9472 9.24071 20.8491 9.11045C20.7509 8.98019 20.613 8.88546 20.4562 8.84061L3.95625 4.03124C3.84456 3.99929 3.72697 3.99373 3.61276 4.01498C3.49855 4.03624 3.39084 4.08374 3.29812 4.15373C3.20541 4.22372 3.13021 4.3143 3.07848 4.41831C3.02674 4.52233 2.99988 4.63694 3 4.75311Z"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 14.5968V18C17.25 18.1989 17.171 18.3896 17.0303 18.5303C16.8897 18.6709 16.6989 18.75 16.5 18.75H13.5C13.3011 18.75 13.1103 18.6709 12.9697 18.5303C12.829 18.3896 12.75 18.1989 12.75 18V6.59058"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3610_2697">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_3610_2697">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
